<template>
  <div>
    <div class="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-2">
      <h2 class="fw-bold m-0">Zarządzanie Rezerwacjami</h2>
      <button class="btn btn-warning btn-sm fw-bold">
        <font-awesome-icon icon="fa-solid fa-rotate" class="me-1" /> Odśwież
      </button>
    </div>

    <div v-if="isLoading" class="text-center py-5">
      <div class="spinner-border text-warning" role="status">
        <span class="visually-hidden">Ładowanie...</span>
      </div>
      <p class="mt-3 text-muted">Ładowanie rezerwacji...</p>
    </div>

    <div v-else class="table-responsive card border-0 shadow-sm">
      <WeekView :reservations="reservations"/>
    </div>
  </div>
</template>

<script>
import WeekView from "./components/WeekView.vue";

export default {
  name: 'AdminReservations',
  components: {WeekView},
  data() {
    return {
      isLoading: false,
      reservations: []
    }
  }
}
</script>